export default "__VITE_ASSET__Dxys1Rb6__"